/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Distance_LabelInputs */

const en_checkout_distance_label = /** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance to Kitchen:`)
};

const es_checkout_distance_label = /** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancia a la Cocina:`)
};

const fr_checkout_distance_label = /** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance jusqu'à la cuisine :`)
};

const de_checkout_distance_label = /** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernung zur Küche:`)
};

const id_checkout_distance_label = /** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak ke Dapur:`)
};

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const ja_checkout_distance_label = en_checkout_distance_label;

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const zh_checkout_distance_label = en_checkout_distance_label;

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const ar_checkout_distance_label = en_checkout_distance_label;

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const it_checkout_distance_label = en_checkout_distance_label;

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const ru_checkout_distance_label = en_checkout_distance_label;

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const pt_checkout_distance_label = en_checkout_distance_label;

/** @type {(inputs: Checkout_Distance_LabelInputs) => LocalizedString} */
const ko_checkout_distance_label = en_checkout_distance_label;

/**
* | output |
* | --- |
* | "Distance to Kitchen:" |
*
* @param {Checkout_Distance_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_distance_label = /** @type {((inputs?: Checkout_Distance_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Distance_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_distance_label(inputs)
	if (locale === "es") return es_checkout_distance_label(inputs)
	if (locale === "fr") return fr_checkout_distance_label(inputs)
	if (locale === "de") return de_checkout_distance_label(inputs)
	if (locale === "ja") return ja_checkout_distance_label(inputs)
	if (locale === "zh") return zh_checkout_distance_label(inputs)
	if (locale === "ar") return ar_checkout_distance_label(inputs)
	if (locale === "id") return id_checkout_distance_label(inputs)
	if (locale === "it") return it_checkout_distance_label(inputs)
	if (locale === "ru") return ru_checkout_distance_label(inputs)
	if (locale === "pt") return pt_checkout_distance_label(inputs)
	return ko_checkout_distance_label(inputs)
});